import { render, staticRenderFns } from "./CofisczToptrans.vue?vue&type=template&id=e5d9198e&scoped=true&"
import script from "./CofisczToptrans.vue?vue&type=script&lang=js&"
export * from "./CofisczToptrans.vue?vue&type=script&lang=js&"
import style0 from "./CofisczToptrans.vue?vue&type=style&index=0&id=e5d9198e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d9198e",
  null
  
)

export default component.exports